exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7645b363] .el-loading-mask{background-color:#1e4960!important;opacity:1!important}[data-v-7645b363] .el-pagination.is-background.el-pagination--small .el-pager li{min-width:24px;margin:0 5px;padding:0 4px}", ""]);

// exports
